import { Address } from '@weave/schema-gen-ts/dist/schemas/brand-settings/v1/settings.pb';

/**
 * formatLocationAddress converts a location address object into a human readable string.
 *
 * @param address - location address object to be formatted
 * @returns human readable address string (e.g. "123 Main St, Provo, UT 84601")
 */
export const formatLocationAddress = (address?: Address) => {
  if (!address) return '';

  const { address: street, address2: street2, city, state, zipCode } = address;
  const stateAndZip = [state, zipCode].filter(Boolean).join(' ');
  return [street, street2, city, stateAndZip].filter(Boolean).join(', ');
};
